import React from "react"

interface FieldInstructionProps {
    instruction: string
}

const FieldInstruction: React.FC<FieldInstructionProps> = ({ instruction }) => {


    const formatText = (text: string) => {

        return text.split("\n").map((line, index) => (
            <span key={index} style={{ display: "block" }}>
                {line.split(/(\*.*?\*)/).map((part, i) =>
                    /\*.*?\*/.test(part) ? (
                        <strong key={i}>{part.replace(/\*/g, "")}</strong>
                    ) : (
                        part
                    )
                )}
            </span>
        ))
    }

    return (
        <span className="field-instruction">{formatText(instruction)}</span>
    )
}

export default FieldInstruction